import { Surgery, SurgeryTypes } from "../models";

export const getSurgeryTypeAbbreviation = (surgery: Surgery | undefined) => {
    if (!surgery) return "";
    switch (surgery.surgeryType?.name) {
        case SurgeryTypes.EK_DMEK:
        case SurgeryTypes.EK_DSEK_DSAEK_DLEK:
            return "EK";
        case SurgeryTypes.ALK_DALK:
        case SurgeryTypes.ALK_OTHER:
            return "ALK";
        case SurgeryTypes.GLAUCOMA_SHUNT_PATCH:
            return "Glauc.";
        case SurgeryTypes.ENCULEATION:
            return "Enucl.";
        case SurgeryTypes.LID_RETRACTION:
            return "Lid Retr.";
        case SurgeryTypes.OTHER_KERATOPLASTY:
        case SurgeryTypes.OTHER:
            return "Other";
        case SurgeryTypes.WHOLE_SCLERA:
            return "W Scl.";
        case SurgeryTypes.HALF_SCLERA:
            return "Half Scl.";
        case SurgeryTypes.QUARTER_SCLERA:
            return "Qtr Scl.";
        case SurgeryTypes.WHOLE_GLYCEROL_PLUS_CORNEA:
            return "Gl + C";
        case SurgeryTypes.HALF_GLYCEROL_PLUS_CORNEA:
            return "Half Gl + C";
        case SurgeryTypes.SPLIT_CORNEA:
            return "Split C";
        default:
            return surgery.surgeryType?.name;
    }
};

export const getSurgeryTypeColorClass = (surgery: Surgery | undefined) => {
    switch (surgery?.surgeryType?.name) {
        case SurgeryTypes.EK_DMEK:
            return "dmek-bg";
        case SurgeryTypes.EK_DSEK_DSAEK_DLEK:
            return "dsaek-bg";
        case SurgeryTypes.ALK_OTHER:
            return "alk-bg";
        default:
            return "";
    }
};
